import axios from 'axios';
import API_CONFIG from '../config/api.config';

// Create an axios instance with API key authentication for public booking
const apiKeyHttpClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': import.meta.env.VITE_PUBLIC_API_KEY || 'your-public-api-key-here',
  },
  withCredentials: false,
});

// Add a request interceptor to handle API paths
apiKeyHttpClient.interceptors.request.use(config => {
  // Only modify the URL if it's a relative URL and not already an API URL
  if (config.url && !config.url.startsWith('http')) {
    // Ensure the URL starts with a slash
    const url = config.url.startsWith('/') ? config.url : `/${config.url}`;
    // If the URL doesn't start with /api, add it
    if (!url.startsWith('/api/')) {
      config.url = `/api${url}`;
    } else {
      config.url = url;
    }
  }
  return config;
});

// Add response interceptor for error handling
apiKeyHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('API Key authentication failed');
    }
    return Promise.reject(error);
  }
);

export default apiKeyHttpClient;
